import * as React from "react";

import type { FeatureFlagSet } from "client/defs";

import { useFeatureFlags } from "client/hooks";

import type { VariantProps } from "./Variant";

export type FallbackProps = {
  fallback: React.ReactNode;
  flag: keyof FeatureFlagSet;
};

export type Experiment = { flag: string; variant: string | boolean };

export const VariantContext = React.createContext<Experiment | undefined>(
  undefined
);

export const ExperimentVariantProvider: React.FC<{
  experiment?: Experiment;
}> = ({ children, experiment }) => (
  <VariantContext.Provider value={experiment}>
    {children}
  </VariantContext.Provider>
);

export const Experiment: React.FC<FallbackProps> = ({
  children,
  flag,
  fallback,
}) => {
  const [allFlags] = useFeatureFlags();
  const ourFlag = allFlags[flag];
  let child = fallback;

  React.Children.forEach(children, (element) => {
    if (!children) {
      child = fallback;
    }
    if (
      (element as React.ReactElement<VariantProps>).props.type === ourFlag ||
      (Array.isArray((element as React.ReactElement).props.type) &&
        (element as React.ReactElement).props.type?.includes(ourFlag))
    ) {
      child = element;
    }
  });
  return (
    <ExperimentVariantProvider experiment={{ variant: ourFlag, flag }}>
      {child}
    </ExperimentVariantProvider>
  );
};
